<template>
  <div class="uni-max row m-0 calpage-d">
    <div class="col-lg-6 cd-padding d-flex flex-column">
      <nav>
        <div class="nav nav-tabs details-cal-pills border-0" id="nav-tab" role="tablist" style="background:var(--p4surface5, #1C1C1C)">
          <a class="nav-item nav-link active" id="nav-mys" style="background:none;" data-toggle="tab" href="#mys" role="tab" aria-controls="nav-mys" aria-selected="true">Malaysia PR</a>
          <a class="nav-item nav-link" id="nav-nonpr" style="background:none;" data-toggle="tab" href="#nonpr" role="tab" aria-controls="nav-nonpr" aria-selected="true">Non-PR</a>
          <a class="nav-item nav-link" id="nav-company" style="background:none;" data-toggle="tab" href="#company" role="tab" aria-controls="nav-company" aria-selected="true">Company</a>
        </div>
      </nav>

      <div class="tab-content" id="nav-tabContent">
        <!-- Malaysian -->
        <div class="tab-pane fade show active" id="mys" role="tabpanel" aria-labelledby="nav-mys">
          <div class="cal-results mx-2">
            <div class="py-4 px-2 uni-max-xs">
              <div class="cal-table">
                <table class="max-100">
                  <thead>
                    <tr>
                      <th class="first">Years of Ownership</th>
                      <td>{{this.holdPeriod}}</td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th class="first">Gross Property Gain (RM)</th>
                      <td>{{addComma(this.sgpGain)}}</td>
                    </tr>
                    <tr>
                      <th class="first">Exemption Waiver (RM)</th>
                      <td>{{addComma(this.sexeWaive)}}</td>
                    </tr>
                    <tr>
                      <th class="first">RPGT Rate (%)</th>
                      <td>{{this.srpgtRate}}</td>
                    </tr>
                    <tr>
                      <th class="first">RPGT Payable (RM)</th>
                      <td>{{addComma(this.srpgtTotal)}}</td>
                    </tr>
                    <tr>
                      <th class="first">Net Property Gain (RM)</th>
                      <td>{{addComma(this.snpGain)}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <!-- Non PR -->
        <div class="tab-pane fade" id="nonpr" role="tabpanel" aria-labelledby="nav-nonpr">
          <div class="cal-results mx-2">
            <div class="py-4 px-2 uni-max-xs">
              <div class="cal-table">
                <table class="max-100">
                  <thead>
                    <tr>
                      <th class="first">Years of Ownership</th>
                      <td>{{this.holdPeriod}}</td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th class="first">Gross Property Gain (RM)</th>
                      <td>{{addComma(this.sgpGain)}}</td>
                    </tr>
                    <tr>
                      <th class="first">Exemption Waiver (RM)</th>
                      <td>0</td>
                    </tr>
                    <tr>
                      <th class="first">RPGT Rate (%)</th>
                      <td>{{this.srpgtRateNPR}}</td>
                    </tr>
                    <tr>
                      <th class="first">RPGT Payable (RM)</th>
                      <td>{{addComma(this.srpgtTotalNPR)}}</td>
                    </tr>
                    <tr>
                      <th class="first">Net Property Gain (RM)</th>
                      <td>{{addComma(this.snpGainNPR)}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <!-- Comapny -->
        <div class="tab-pane fade" id="company" role="tabpanel" aria-labelledby="nav-company">
          <div class="cal-results mx-2">
            <div class="py-4 px-2 uni-max-xs">
              <div class="cal-table">
                <table class="max-100">
                  <thead>
                    <tr>
                      <th class="first">Years of Ownership</th>
                      <td>{{this.holdPeriod}}</td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th class="first">Gross Property Gain (RM)</th>
                      <td>{{addComma(this.sgpGain)}}</td>
                    </tr>
                    <tr>
                      <th class="first">Exemption Waiver (RM)</th>
                      <td>0</td>
                    </tr>
                    <tr>
                      <th class="first">RPGT Rate (%)</th>
                      <td>{{this.srpgtRateC}}</td>
                    </tr>
                    <tr>
                      <th class="first">RPGT Payable (RM)</th>
                      <td>{{addComma(this.srpgtTotalC)}}</td>
                    </tr>
                    <tr>
                      <th class="first">Net Property Gain (RM)</th>
                      <td>{{addComma(this.snpGainC)}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-lg-6 cd-padding">
      <div class="cal-form-container">
        <div class="cal-label">Purchase Price</div> 
        <div class="filter-price-wrapper">
          <span class="filter-price-rm">RM</span>
          <input type='number' v-model="purcPrice" class="filter-price-range">
        </div>

        <div class="cal-label">Selling Price</div> 
        <div class="filter-price-wrapper">
          <span class="filter-price-rm">RM</span>
          <input type='number' v-model="sellPrice" class="filter-price-range">
        </div>

        <div class="cal-label">Holding Period</div> 
        <div class="filter-price-wrapper">
          <input type='number' v-model="holdPeriod" class="filter-price-range" placeholder="Number of years">
          <span class="filter-price-rm w-auto ml-auto">years</span>
        </div>

        <div class="cal-label">Allowable Expenses (Optional)</div> 
        <div class="filter-price-wrapper">
          <span class="filter-price-rm">RM</span>
          <input type='number' v-model="expTotal" class="filter-price-range">
        </div>
        <div class="mt-2"><small>Legal fees, angency fees, renovation costs and others</small></div>

        <button @click="calculate" class="cal-btn">
          <span v-if="isloaded">Calculate</span>
          <div v-else class="spinner-border text-light" role="status" style="width: 1rem; height: 1rem;">
            <span class="sr-only">Loading...</span>
          </div>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'RPGT',
    data: function () {
      return {
        purcPrice: null,
        sellPrice: null,
        holdPeriod: null,
        expTotal: null,
        isloaded: true,

        // Results (update when press calculate)
        sgpGain: '',
        sexeWaive: '',
        srpgtRate: '',
        srpgtRateNPR: '',
        srpgtRateC: '',
        srpgtTotal: '',
        srpgtTotalNPR: '',
        srpgtTotalC: '',
        snpGain: '',
        snpGainNPR: '',
        snpGainC: '',
      }
    },
    mounted() {
      this.purcPrice = 500000;
      this.sellPrice = 800000;
      this.holdPeriod = 5;
      this.expTotal = 0;
        
      this.sgpGain = this.gpGain;
      this.sexeWaive = this.exeWaive;
      this.srpgtRate = this.rpgtRate;
      this.srpgtRateNPR = this.rpgtRateNPR;
      this.srpgtRateC = this.rpgtRateC;
      this.srpgtTotal = this.rpgtTotal;
      this.srpgtTotalNPR = this.rpgtTotalNPR;
      this.srpgtTotalC = this.rpgtTotalC;
      this.snpGain = this.npGain;
      this.snpGainNPR = this.npGainNPR;
      this.snpGainC = this.npGainC;
    },
    computed: {
      gpGain() {
        return (this.sellPrice - this.purcPrice - this.expTotal).toFixed(2);
      },
      exeWaive() {
        return (parseFloat(this.gpGain) * 0.1).toFixed(2);
      },
      rpgtRate() {
        var rate = 0;
        if (this.holdPeriod < 4) {
          rate = 30;
        } else if (this.holdPeriod >= 4 && this.holdPeriod < 5) {
          rate = 20;
        } else if (this.holdPeriod >= 5 && this.holdPeriod < 6) {
          rate = 15;
        } else if (this.holdPeriod >= 6) {
          rate = 5;
        }
        return rate
      },
      rpgtRateNPR() {
        var rate = 0;
        if (this.holdPeriod < 6) {
          rate = 30;
        } else if (this.holdPeriod >= 6) {
          rate = 10;
        }
        return rate
      },
      rpgtRateC() {
        var rate = 0;
        if (this.holdPeriod < 4) {
          rate = 30;
        } else if (this.holdPeriod >= 4 && this.holdPeriod < 5) {
          rate = 20;
        } else if (this.holdPeriod >= 5 && this.holdPeriod < 6) {
          rate = 15;
        } else if (this.holdPeriod >= 6) {
          rate= 10;
        }
        return rate
      },
      rpgtTotal() {
        return ((parseFloat(this.gpGain) - parseFloat(this.exeWaive)) * parseFloat(this.rpgtRate) / 100).toFixed(2);
      },
      rpgtTotalNPR() {
        return (parseFloat(this.gpGain) * parseFloat(this.rpgtRateNPR) / 100).toFixed(2);
      },
      rpgtTotalC() {
        return (parseFloat(this.gpGain) * parseFloat(this.rpgtRateC) / 100).toFixed(2);
      },
      npGain() {
        return (parseFloat(this.gpGain) - parseFloat(this.rpgtTotal)).toFixed(2);
      },
      npGainNPR() {
        return (parseFloat(this.gpGain) - parseFloat(this.rpgtTotalNPR)).toFixed(2);
      },
      npGainC() {
        return (parseFloat(this.gpGain) - parseFloat(this.rpgtTotalC)).toFixed(2);
      },
    },
    methods: {
      addComma: function (num) {
        if (num != null) {
          var num_parts = num.toString().split(".");
          num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          return num_parts.join(".");
        } else {
          return '';
        }
      },
      isEven: function (n) {
        var num = n;
        if (Math.floor(n) % 2 == 0) { // is even with decimal
          num = Math.round(n)
          if (num % 2 != 0) {
            num = num + 1
          }
        } else { // is odd with decimal
          num = Math.floor(n) + 1;
        }
        return num;
      },
      calculate: function() {
        this.isloaded = false;

        setTimeout(() => {
          window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
          });
          this.isloaded = true;

          // Update Results
          this.sgpGain = this.gpGain;
          this.sexeWaive = this.exeWaive;
          this.srpgtRate = this.rpgtRate;
          this.srpgtRateNPR = this.rpgtRateNPR;
          this.srpgtRateC = this.rpgtRateC;
          this.srpgtTotal = this.rpgtTotal;
          this.srpgtTotalNPR = this.rpgtTotalNPR;
          this.srpgtTotalC = this.rpgtTotalC;
          this.snpGain = this.npGain;
          this.snpGainNPR = this.npGainNPR;
          this.snpGainC = this.npGainC;
        }, 500);
      }
    },
  }
</script>